import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import courseService from "services/api/courseService";

export const fetchCourses = createAsyncThunk("courses/fetchAllCourses", async () => {
    const res = await courseService.findAllCoursesOrderByPeriod();
    //console.log("courses (redux)", res);
    return res.data;
});

const coursesSlice = createSlice({
    name: "courses",
    initialState: {
        data: [],
        status: "idle", // idle | loading | succeeded | failed
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCourses.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchCourses.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.data = action.payload;
            })
            .addCase(fetchCourses.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });
    },
});

export default coursesSlice.reducer;
